import {redirect} from "react-router-dom";

export function getUser() {
  return JSON.parse(localStorage.getItem('user')) || null;
}

export function checkAuthLoader() {
  const user = getUser();
  if (!user) {
    return redirect('/login');
  }

  return true;
}
export function checkPermission(checkList, type = 'every') {
  const user = getUser();

if(user){
  let permissions = user.permissions
  if(permissions.length && checkList) {
    if (type === 'every') {
      return checkList.every(item => permissions.includes(item));
    } else {
      return checkList.some(item => permissions.includes(item));
    }
  } else return false
}


}